import dayjs from 'dayjs'
import { jwtDecode } from 'jwt-decode'
import { Cookies } from 'react-cookie'

import { removeFromLocalStorage } from '../../helpers/localstorage'

const cookieManager = new Cookies()

export type AuthenticationParams = {
  token?: string
  refreshToken?: string
  tokenExpiresAt?: Date
}

export const setAuthenticationCookie = ({ refreshToken, token, tokenExpiresAt }: AuthenticationParams) => {
  if (token) {
    cookieManager.set('token', token, {
      path: '/',
      sameSite: 'strict',
      secure: true,
      expires: dayjs().add(1, 'year').toDate(),
    })
  }

  if (refreshToken) {
    cookieManager.set('refreshToken', refreshToken, {
      path: '/',
      sameSite: 'strict',
      secure: true,
      expires: dayjs().add(1, 'year').toDate(),
    })
  }
  if (tokenExpiresAt) {
    cookieManager.set('tokenExpiresAt', new Date(tokenExpiresAt).toISOString(), {
      path: '/',
      sameSite: 'strict',
      secure: true,
      expires: dayjs().add(1, 'year').toDate(),
    })
  }
}

export const cleanAuthenticationCookie = () => {
  cookieManager.remove('token', { path: '/' })
  cookieManager.remove('refreshToken', { path: '/' })
  cookieManager.remove('tokenExpiresAt', { path: '/' })
  removeFromLocalStorage('persist:root')
}

export const getCookie = (key: 'token' | 'refreshToken' | 'tokenExpiresAt'): string | null => {
  const token = cookieManager.get(key)
  if (typeof token !== 'string' || token === 'null' || token === 'undefined') {
    return null
  }
  return token
}

export const getUserIdFromAuthToken = () => {
  const token = getCookie('token')
  if (!token) {
    return null
  }
  try {
    const decodedToken = jwtDecode<{
      userId: number
      exp: number
    } | null>(token)
    if (!decodedToken) return null
    return decodedToken.userId
  } catch {
    return null
  }
}

export const setImpersonnationCookie = ({ token, tokenExpiresAt }: Omit<AuthenticationParams, 'refreshToken'>) => {
  cookieManager.set('token', token, {
    expires: tokenExpiresAt ? new Date(tokenExpiresAt) : dayjs().add(5, 'minutes').toDate(),
    path: '/',
  })
  cookieManager.remove('refreshToken', { path: '/' })
}
